import routeProviderConfig from './configs/routeProvider.config';
import httpProviderConfig from './configs/httpProvider.config';
import AuthInterceptor from './services/authInterceptor';
import FullStory from './services/fullStory';

import accounts from './components/accounts/accounts.component';
import login from './components/login/login.component';
import logout from './components/logout/logout.component';
import tos from './components/tos/tos.component';

import AUTH_EVENTS from './constants/authEvents.constants';

import userSession from './eventSubscribers/userSession';

/**
 * @ngdoc overview
 * @name account
 * @description
 * This module handles everything for the Login section.
 */
const loginModule = angular.module('login', [])
.config(routeProviderConfig)
.config(httpProviderConfig)
.service('authInterceptor', AuthInterceptor)
.service('fullStory', FullStory)
.component('accounts', accounts)
.component('login', login)
.component('logout', logout)
.component('tos', tos)
.constant('AUTH_EVENTS', AUTH_EVENTS)
.run(userSession);

export default loginModule.name;



// WEBPACK FOOTER //
// ./src/frontend/modules/account/index.js